import { c as _c } from "react/compiler-runtime";
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import type { OptionalNumber } from '@/lib/piano/touch-design/measured-key.requirements';
import { useCallback } from 'react';
import type { TouchDesignSerieVariant } from '../KeyboardChart';
import type { TouchDesignDataPoint, TouchDesignSerie } from '../interfaces';
export const useGenerateSerie = keyboard => {
  const $ = _c(4);
  let t0;
  if ($[0] !== keyboard) {
    t0 = (valueSelector, name, variant) => {
      const data = keyboard.map(key => valueSelector(key) ?? undefined).getKeys();
      return {
        data,
        name,
        variant
      };
    };
    $[0] = keyboard;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const generateSerie = t0;
  const isSerieEmpty = _temp2;
  let t1;
  if ($[2] !== generateSerie) {
    t1 = {
      generateSerie,
      isSerieEmpty
    };
    $[2] = generateSerie;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(d) {
  return d.payload === undefined || d.payload === null || isNaN(d.payload);
}
function _temp2(serie) {
  return serie.data.every(_temp);
}